/**********************************************************************************************************************/
/* FILE: hafas_webapp_controller_banner.js                                                                            */
/**********************************************************************************************************************/

(function (HafasWebapp) {

  var bannerSizes = {
    smallBanner: {
      width: "100%",
      height: 100,
      autoHeight: true
    },
    popBanner: {
      width: 300,
      height: 300,
      autoHeight: true
    },
    mapBanner: {
      width: "100%",
      height: 100,
      autoHeight: true
    }

  };

  /**
   * Bei TRM werden Location über die folgenden IDs in Typen eingeteilt.
   * @type {{DESTINATION: number, WORK: number, DEPARTURE_BOARD: number, CURRENT: number, HOME: number, ARRAY_OF_ROUTES: number}}
   */
  var TRM_LOCATION_TYPES = {
    CURRENT: 0,
    HOME: 1,
    WORK: 2,
    DESTINATION: 3,
    DEPARTURE_BOARD: 4,
    ARRAY_OF_ROUTES: 5
  }

  var bannerContainerConfigs = {
    sidedrawerTop: {
      position: "top",
      page: "navigation_drawer",
      nodeId: "HFS_TRMBannerSidedrawerTop",
      size: bannerSizes.smallBanner,
      tag: "sidedrawer",
      enabled: true
    },
    sidedrawerBottom: {
      position: "bottom",
      page: "navigation_drawer",
      nodeId: "HFS_TRMBannerSidedrawerBottom",
      size: bannerSizes.smallBanner,
      tag: "sidedrawer",
      enabled: true
    },
    tpInputTop: {
      position: "top",
      page: "connection_request",
      nodeId: "HFS_TRMBannerTPInputTop",
      size: bannerSizes.smallBanner,
      tag: "tpInput",
      enabled: true
    },
    tpOverviewTop: {
      position: "top",
      page: "connection_overview",
      nodeId: "HFS_TRMBannerTPOVTop",
      size: bannerSizes.smallBanner,
      tag: "tpOverview",
      enabled: true
    },
    tpOverviewBottom: {
      position: "bottom",
      page: "connection_overview",
      nodeId: "HFS_TRMBannerTPOVBottom",
      size: bannerSizes.smallBanner,
      tag: "tpOverview",
      enabled: true
    },
    tpOverviewPop: {
      position: "pop",
      page: "connection_overview",
      nodeId: "HFS_TRMBannerTPOVPop",
      size: bannerSizes.popBanner,
      tag: "tpOverview",
      enabled: false
    },
    tpDetailsTop: {
      position: "top",
      page: "connection_details",
      nodeId: "HFS_TRMBannerTPDetailsTop",
      size: bannerSizes.smallBanner,
      tag: "tpDetails",
      enabled: true
    },
    tpDetailsBottom: {
      position: "bottom",
      page: "connection_details",
      nodeId: "HFS_TRMBannerTPDetailsBottom",
      size: bannerSizes.smallBanner,
      tag: "tpDetails",
      enabled: true
    },
    tpDetailsPop: {
      position: "pop",
      page: "connection_details",
      nodeId: "HFS_TRMBannerTPDetailsPop",
      size: bannerSizes.popBanner,
      tag: "tpDetails",
      enabled: false
    },
    lineDetailsTop: {
      position: "top",
      page: "journey_details",
      nodeId: "HFS_TRMBannerLineDetailsTop",
      size: bannerSizes.smallBanner,
      tag: "tq",
      enabled: true
    },
    lineDetailsBottom: {
      position: "bottom",
      page: "journey_details",
      nodeId: "HFS_TRMBannerLineDetailsBottom",
      size: bannerSizes.smallBanner,
      tag: "tq",
      enabled: true
    },
    lineDetailsPop: {
      position: "pop",
      page: "journey_details",
      nodeId: "HFS_TRMBannerLineDetailsPop",
      size: bannerSizes.popBanner,
      tag: "tq",
      enabled: false
    },
    sqFormTop: {
      position: "top",
      page: "departure_request",
      nodeId: "HFS_TRMBannerSQFormTop",
      size: bannerSizes.smallBanner,
      tag: "sqInput",
      enabled: true
    },
    sqResultTop: {
      position: "top",
      page: "departure_result",
      nodeId: "HFS_TRMBannerSQResultTop",
      size: bannerSizes.smallBanner,
      tag: "sqResult",
      enabled: true
    },
    sqResultBottomDep: {
      position: "bottom",
      page: "departure_result",
      nodeId: "HFS_TRMBannerSQResultBottom_DEP",
      size: bannerSizes.smallBanner,
      tag: "sqResult",
      enabled: true
    },
    sqResultBottomArr: {
      position: "bottom",
      page: "departure_result",
      nodeId: "HFS_TRMBannerSQResultBottom_ARR",
      size: bannerSizes.smallBanner,
      tag: "sqResult",
      enabled: true
    },
    mapTop: {
      position: "top",
      page: "mobility_map",
      nodeId: "HFS_TRMBannerMap",
      size: bannerSizes.mapBanner,
      tag: "map",
      enabled: true
    },
    mapPop: {
      position: "pop",
      page: "mobility_map",
      nodeId: "HFS_TRMBannerMapPop",
      size: bannerSizes.popBanner,
      tag: "map",
      enabled: false
    }
  };

  var BannerStates = {
    "INIT": "INIT",
    "LOAD": "LOAD",
    "READY": "READY",
    "NO_BANNER": "NO_BANNER",
    "DISMISS": "DISMISS"
  };

  function BannerContainer(key, config) {
    this.key = key;
    this.config = config;
    this.iframe = null;
    this.bannerApp = null;
    this.node = null;
    this.state = BannerStates.INIT;
    this.toString = function () {
      return "[BannerContainer-> key:" + this.key + " page:" + this.config.page + " pos:" + this.config.position + " state:" + this.state + "]";
    }
  }

  function TestBannerApp(params, callback) {

    this.isTestBanner = true;
    var iframe = null;
    var variation = 0;

    this.next = function () {
      variation++;
      if(iframe) iframe.src = createIFrameSrc();
      console.log("TextBannerApp.next() page=" + params.page);
      callback(iframe);
    };

    function createTestIframe() {
      iframe = document.createElement("iframe");
      iframe.className = "trm-banner-block";
      iframe.width = params.width;
      iframe.height = params.height;
      iframe.frameBorder = 0;
      iframe.style.backgroundColor = "transparent";
      iframe.src = createIFrameSrc();
      return iframe;
    }

    function createIFrameSrc() {
      return "./staticfiles/trm-test-banner.html?page=" + params.page + "&pos=" + params.position + "&variation=" + variation;
    }

    createTestIframe();

    setTimeout(function () {
      callback(iframe);
    }, 300
    );
  }

  /**
   * Hacon coods to trm coords
   * @method convertLocation
   * @param {{x: number, y: number}} coord Object with coordinates
   * @returns {{lng: number, lat: number}}
   */
  function convertLocation(coord) {
    return {
          lat: coord.y / 1000000,
          lng: coord.x / 1000000
        };
  }

  function BannerControl() {
    this.bannerContainerList = [];
    this.userLocations = {};

    this.init = function () {
      this.bannerContainerList = [];

      for (var key in bannerContainerConfigs) {
        var bannerConfig = bannerContainerConfigs[key];
        if (bannerConfig.enabled) {
          var bannerContainer = new BannerContainer(key, bannerConfig);
          this.bannerContainerList.push(bannerContainer);
        }
      }
    };

    /**
     * Logs text and object (optional) if the URL parameter debugTRM is set
     * @method log
     * @param {string} text Text that should be logged
     * @param {object=} obj Object that should be logged
     */
    this.log = function(text, obj) {
      var logText = "WebApp-TRM -> " + text;
      if(Hafas.Config.TRM.debug) {
        if(obj) {
          console.log(logText, obj);
        }
        else {
          console.log(logText);
        }
      }
    };

    this.getLanguageCode = function() {
        var currentLang = Hafas.Config.currLangObj.lang;
        if(Hafas.Config.TRM.language.mapping[currentLang] === undefined)
        {
          return Hafas.Config.TRM.language.fallback;
        }
        return Hafas.Config.TRM.language.mapping[currentLang];
    }

    this.loadBanner = function (bannerContainer) {
      this.log("loadBanner", bannerContainer.toString());
      bannerContainer.iframe = null;
      var bannerParams = {
        page: Hafas.Config.TRM.pagePreset + bannerContainer.config.page,
        position: bannerContainer.config.position,
        width: bannerContainer.config.size.width,
        height: bannerContainer.config.size.height,
        autoHeight: bannerContainer.config.size.autoHeight,
        languageCode: this.getLanguageCode(),
        onDismiss: function () {
          bannerContainer.state = BannerStates.DISMISS;
          this.removeBannerIframe(bannerContainer);
        }.bind(this)
      };
      if (Hafas.Config.TRM.apiKey) {
        bannerParams.apiKey = Hafas.Config.TRM.apiKey;
      }
      if (bannerContainer.config.cluster !== undefined) {
        if (bannerParams.externalFilterParams === undefined) {
          bannerParams.externalFilterParams = [];
        }
        bannerParams.externalFilterParams.push({name: "haf_con_cluster", value: bannerContainer.config.cluster});
      }
      bannerParams.locations = this.userLocations;
      bannerParams.isTestApp = !!Hafas.Config.TRM.useTestBanner;
      bannerParams.debug = !!Hafas.Config.TRM.debug;
      if(Hafas.Config.TRM.debug) {
        this.log("debug modus on. Load: " +
          Hafas.Config.TRM.pagePreset + bannerContainer.config.page +
          "." + bannerContainer.config.position);
      }
      bannerContainer.state = BannerStates.LOAD;
      if (Hafas.Config.TRM.useFakeBanner) {
        this.log("Use fake banner");
        bannerContainer.bannerApp = new TestBannerApp(bannerParams, function (response) {
          this.onBannerChange(response, bannerContainer);
        }.bind(this));
      }
      else {
        try {
          bannerContainer.bannerApp = new BannerApp(bannerParams, function (response) {
            this.onBannerChange(response, bannerContainer);
          }.bind(this));
        }catch (e) {
          // Catch errors, that errors in banner.js won't stop our code from executing
          if (Hafas.Config.TRM.debug) {
            console.trace('Caught TRM error', e);
          }
        }
      }
    };

    /**
     * Wird ausgeführt wenn der Banner sind änder. Das kann passieren, wenn er zum ersten Mal geladen wurde, oder durch den Aufruf von next() erneut abgefragt wird.
     * @method onBannerChange
     * @param response
     * @param {BannerContainer} bannerContainer Object from type BannerContainer
     */
    this.onBannerChange = function (response, bannerContainer) {
      this.log("onBannerChange", bannerContainer.toString());

      if (response != null) {
        bannerContainer.state = BannerStates.READY;
        bannerContainer.iframe = response;
        this.addIframeToContainer(bannerContainer);
      } else {
        if (Hafas('#' + bannerContainer.config.nodeId, false) != null) {
          Hafas('#' + bannerContainer.config.nodeId, false).innerHTML = '';
        }
        bannerContainer.state = BannerStates.NO_BANNER;
        delete bannerContainer.iframe;
        this.removeBannerIframe(bannerContainer);
      }
    };

    this.showAllBannerForTag = function (tag) {
      this.log("showAllBannerForTag", tag);
      for (var i in this.bannerContainerList) {
        var bannerContainer = this.bannerContainerList[i];
        if (tag === null || bannerContainer.config.tag === tag) {
          this.onShowBanner(bannerContainer);
        }
      }
      Hafas.ps.pub('/app/events/resize');
    };

    this.setLocation = function(trmLocationType, location) {
      this.userLocations[trmLocationType] = location;
      this.updateLocations();
    }

    /**
     * For all banner containers in the bannerContainerList it calls the updateUserLocations function from the banner app
     * (function from external banner.js) and updateBanner (call next banner) afterwards.
     * @method updateLocations
     */
    this.updateLocations = function () {
      this.log("updateLocations", this.userLocations);
      for (var i = 0; i < this.bannerContainerList.length; i++) {
        var bannerContainer = this.bannerContainerList[i];
        if (bannerContainer.bannerApp) {
          bannerContainer.bannerApp.updateUserLocations(this.userLocations);
          this.updateBanner(bannerContainer);
        }
      }
    }

    /**
     * Für einen Banner-Container wird ein Banner angezeigt.
     * @method onShowBanner
     * @param {BannerContainer} bannerContainer Object from type BannerContainer
     */
    this.onShowBanner = function (bannerContainer) {
      this.log("onShowBanner", bannerContainer.toString());

      switch (bannerContainer.state) {

        // Banner wurde noch nicht angezeigt
        case BannerStates.INIT:
          this.loadBanner(bannerContainer);
          break;

        // Banner wird schon geladen
        case BannerStates.LOAD:
          break;

        //Banner wurde schon geladen und entweder angezeigt oder verworfen.
        case BannerStates.NO_BANNER:
        case BannerStates.DISMISS:
        case BannerStates.READY:
          // Banner wird neu geladen.
          this.updateBanner(bannerContainer);
          break;
      }
    };
    /**
     * Der Banner wird erneut geladen. Möglicherweise gibt es mehere Banner an dieser Position, oder due User Location hat sich geändert.
     * @method updateBanner
     * @param {BannerContainer} bannerContainer Object from type BannerContainer
     */
    this.updateBanner = function(bannerContainer) {
      this.log("updateBanner", bannerContainer.toString());
      try {
        bannerContainer.bannerApp.next();
      } catch (e) {
        // Catch errors, that errors in banner.js won't stop our code from executing
        if (Hafas.Config.TRM.debug) {
          console.trace('Caught TRM error', e);
        }
      }
    };
    this.removeBannerIframe = function(bannerContainer) {
      this.log("removeBannerIframe", bannerContainer.toString());
      var node = Hafas("#" + bannerContainer.config.nodeId);
      if (node === null) {
        return;
      }
          node.addClassName("lyr_hideBanner");
          node.removeClassName("lyr_showBanner");
          node.innerHTML = "";
    };
    this.addIframeToContainer = function (bannerContainer) {
      this.log("addIframeToContainer", bannerContainer.toString());
      var node = Hafas("#" + bannerContainer.config.nodeId);
      if (node === null) {
        // Der TRM hat keinen holder -> überspringen.
        console.log("no holder! " + bannerContainer.toString());
        return;
      }
      if (bannerContainer.iframe === null) {
        // TRM hat keinen iframe -> überspringen
        console.log("no iframe: " + bannerContainer.toString());
        if (node !== null) {
          node.style.display = "none";
        }
        return;
      }

      if (node != null && node.getElementsByTagName("iframe").length > 0) {
        // Das Bannernode hat schon seinen iframe -> überpsringen
        return;
      }

      // Data Attribute für die Einrichtung
      node.setAttribute('data-page', bannerContainer.config.page + ':' + bannerContainer.config.position);
      node.removeClassName("lyr_hideBanner");

      // Remove height if it's configured to be autoHeight
      if (bannerContainer.config.size !== undefined && bannerContainer.config.size.autoHeight === true) {
        node.addClassName('lyr_bannerAutoHeight');
      }

      if (typeof bannerContainer.iframe != 'undefined') {
        node.appendChild(bannerContainer.iframe);
        node.style.display = "";
        node.addClassName("lyr_showBanner");
      }
    }
    this.getBannerContainerByKey = function (key) {
      for (var i = 0; i < this.bannerContainerList.length; i++) {
        if (this.bannerContainerList[i].key === key)
          return this.bannerContainerList[i];
      }
      return null;
    }
  }

  var bannerControl = new BannerControl();

  /* Controller GUI */
  HafasWebapp.prototype.Controller.TRM = {
    init: function () {
      bannerControl.init();
    },

    showBanner: function (tag) {
      bannerControl.showAllBannerForTag(tag || null);
    },
    /**
     * If TRM geofencing config is activated, set a TRM location in the bannerControl.
     * @method setLocation
     * @param {TRM_LOCATION_TYPES} trmLocationType TRM location type, e.g. CURRENT, DESTINATION, ARRAY_OF_ROUTES ...
     * @param {array|{x:number, y:number}} location Array of poly coordinate array(s) if trmLocationType is ARRAY_OF_ROUTES or an object with x/y coordinates
     */
    setLocation: function(trmLocationType, location) {
      if (Hafas.Config.TRM.useGeofencing) {
        if(TRM_LOCATION_TYPES[trmLocationType]) {
          if (trmLocationType === "ARRAY_OF_ROUTES") {
            bannerControl.setLocation(TRM_LOCATION_TYPES[trmLocationType], location);
          } else {
            bannerControl.setLocation(TRM_LOCATION_TYPES[trmLocationType], convertLocation(location));
          }
        }
        else {
          console.error("TRM: Wrong trm type location. type=" + trmLocationType);
        }
      }
    },
    /**
     * Setze Clusternamen im Banner
     * @method setCluster
     * @param cluster Name des Clusters wie konfiguriert / vom Server erhalten
     */
    setCluster: function (cluster) {
      for (var i = 0; i < bannerControl.bannerContainerList.length; i++) {
        var bannerContainer = bannerControl.bannerContainerList[i];
        if (bannerContainer.config.tag === 'tpOverview') {
          // Setze für die TP Overview Container den Zustand zurück, um neue Initialisierung zu erzwingen und setze den Clusternamen
          bannerContainer.state = BannerStates.INIT;
          bannerContainer.config.cluster = cluster;
          this.Controller.TRM.showBanner(bannerContainer.config.tag);
        }
      }
    },
    printData: function() {
      var data = {
        userLocations: bannerControl.userLocations,
        bannerList: bannerControl.bannerContainerList
      }
      console.log(data);
    },
    /**
     * Calls the next banner for each bannerContainer in the bannerContainerList
     * @method replaceAll
     */
    replaceAll: function () {
      for (var i = 0; i < bannerControl.bannerContainerList.length; i++) {
        var bannerContainer = bannerControl.bannerContainerList[i];
        try {
          bannerContainer.bannerApp.next();
        } catch (e) {
          // Catch errors, that errors in banner.js won't stop our code from executing
          if (Hafas.Config.TRM.debug) {
            console.trace('Caught TRM error', e);
          }
        }
      }
    }
  };

})(HafasWebapp);
